<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.1932 7.51168C20.9685 6.68111 20.3376 6.03376 19.4961 5.80826C18.0096 5.40002 11.9929 5.40002 11.9929 5.40002C11.9929 5.40002 5.99025 5.40002 4.50375 5.80826C3.67625 6.03328 3.03082 6.68111 2.79259 7.51168C2.3999 9.00369 2.3999 12.1427 2.3999 12.1427C2.3999 12.1427 2.3999 15.2818 2.79259 16.7884C3.03082 17.6048 3.67625 18.2663 4.50375 18.4918C5.99025 18.9 11.9929 18.9 11.9929 18.9C11.9929 18.9 18.0096 18.9 19.4961 18.4918C20.3376 18.2668 20.9685 17.6048 21.1932 16.7884C21.5999 15.2823 21.5999 12.1427 21.5999 12.1427C21.5999 12.1427 21.5999 9.00369 21.1932 7.51168ZM10.0856 15.0427V9.25689L15.0646 12.1427L10.0856 15.0427Z"
      fill="currentColor"
    />
  </svg>
</template>
